<template>
    <div class="NotificationSettings">
        <h2>General Settings</h2>
        <div class="row">
            <div class="col-12">
                <div v-for="(setting,index) in NotificationSettingsComp">
                    <b-form-checkbox size="lg" switch v-model="setting.Value" v-on:input="UpdateDatabase(setting.Value,index)">
                        {{setting.CoreProgramSetting.Label}}
                    </b-form-checkbox>
                </div>
            </div>
            <div class="col-12">
                <b-card-group deck>
                    <b-container fluid>
                        <b-row>
                            <b-col cols="12" md="6" lg="4" xl="2" xxl="2" sm="12" xs="12"> 
                                <span style="font-size:larger; white-space:nowrap;"class="pointer" @click="OpenPinModal()">
                                    <font-awesome-icon :icon="['fa', 'key']" />
                                    <b> Set or Update Pin Login</b>
                                </span>
                            </b-col>
                        </b-row>
                    </b-container>

                </b-card-group>
            </div>
        </div>
        <b-modal ref="pin-modal" :title="'Enter pin'" id="pinModal" hide-footer>
            <b-container fluid>
                <b-row class="modal-btn-row">
                    <PinInput DisplayAlertMessage="Pin Saved." DigitLength="6" AuthenticateMethod="Residential/EmployeeCheckIn/SetEmployeePin" :AdditionalPayload="{EmployeeID: EmployeeID}" @update='shakeForm' />
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    import PinInput from '../PinInput.vue';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faKey } from '@fortawesome/free-solid-svg-icons';
    library.add(faKey);
    export default {
         props: [
            "EmployeeID"
        ],
        data: function () {
            return {
                NotificationSettings: [],
                condition: 0,
            }
        },
        methods: {
            UpdateDatabase(Check, index) {
                let vm = this;
                if (this.condition == 0) {
                    this.$MasterAPI.ExecuteRequest("POST", "Core/UserSettings/UpdateUserSettings", {CoreProgramSettingID: this.NotificationSettings[index].CoreProgramSettingID,Value: Check}, () => { }, this.UpdateDatabaseSuccess, false);

                }
                else
                    this.condition = 0;
            },
            UpdateDatabaseError(response) {
                this.NotificationSettings[index].Value = !Check
                this.condition += 1;
            },
            getCurrentSettings() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/UserSettings/GetUserSettings", {Grouping :"Account Settings"}, this.getCurrentSettingsSuccess, () => { }, true);
            },
            getCurrentSettingsSuccess(response) {
                this.NotificationSettings = response.data.data;
            },
            shakeForm() { 
                //distance of shake
                var distance = 20;  
                $(document).ready(function () {
                    //amount of shakes
                    for( var i = 0; i <= 4; i++ ) {   
                    $( '#pinModal' ).animate( { 
                         'margin-left': '+=' + ( distance = -distance ) + 'px',
                         'margin-right': '-=' + distance + 'px'
                      }, 50);  
                    }
                   
                });
                //reset position
                $('#pinModal').css('margin-left', '0px');
                $('#pinModal').css('margin-right', '0px');
            },
            OpenPinModal() {
                this.$refs['pin-modal'].show();
            },
            HidePinModal() {
                this.$refs['pin-modal'].hide();
            },
            GetEmployeeID() {
                this.$parent.UserPrivateProfile.EmployeeID = this.EmployeeID;
            }
        },
         components: {
            PinInput
        },
        computed: {
            CheckedStates: function () {
                return this.NotificationSettings;
            },
            NotificationSettingsComp: function () {
                return this.NotificationSettings;
            }
        },
        mounted: function () {
            this.getCurrentSettings();
            //this.GetEmployeeID();

        }
    }
</script>

<style scoped>
    #question {
        font-weight: bold;
    }

    #Header {
        font-weight: bold;
        color: black;
    }
</style>